"use client";

import Image from "next/image";
import { Button } from "../ui/button";

function BmcButton({ 
  className = "",
}: {
  className?: string;
}) {
  return (
    <a href="https://buymeacoffee.com/joeghanoe" target="_blank" className={className} rel="noopener noreferrer">
      <Button
        className="h-full gap-2 bg-violet-100 hover:bg-violet-600 text-foreground hover:text-white dark:text-foreground dark:bg-violet-600 dark:hover:bg-violet-500 hover:scale-105 hover:-rotate-2 transition-all"
        title="Buy me a coffee"
        aria-label="Buy me a coffee"
      >
        <Image
          src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
          alt="Coffee button logo"
          width={16}
          height={23}
        />
        <span>Buy me a coffee</span>
      </Button>
    </a>
  );
}

export default BmcButton;
